module.exports = __webpack_public_path__ + "img/管控点.5a1c2836.png";